/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * Helper: session Redirect.
 */

/** Redirect to login when an API call fails due to session/auth issues. */
export function redirectToLoginOnSessionError(error, loginWithRedirect) {
    if (typeof loginWithRedirect !== 'function') return;
    loginWithRedirect({ appState: { returnTo: '/' } });
}
